import { lazy } from "react";



const Routes = [
    {
        path: "/",
        component: lazy(() => import('../loginpages/Login.js')),
        name: '/'
    },
    {
        path: "/login/admin",
        component: lazy(() => import('../loginpages/Login.js')),

    },
    {
        path: "/dashboard",
        component: lazy(() => import('../dashboard/Dashboard.js')),
        name: '/admin'
    },
    {
        path: "/currencylist",
        component: lazy(() => import('../currencyList/currencylist.js')),
        name: '/admin'
    },
    {
        path: "/addtoken",
        component: lazy(() => import('../currencyList/addtoken.js')),
        name: '/admin'
    },
    {
        path: "/cmshomelist",
        component: lazy(() => import('../cmsAndFaq/cmshomelist.js')),
        name: '/admin'
    },
    {
        path: "/editcmshome",
        component: lazy(() => import('../cmsAndFaq/editcmshome.js')),
        name: '/admin'
    },
    {
        path: "/addcmshome",
        component: lazy(() => import('../cmsAndFaq/addcmshome.js')),
        name: '/admin'
    },
    {
        path: "/userlist",
        component: lazy(() => import('../user/userlist')),
        name: '/admin'
    },
    {
        path: "/userdetail",
        component: lazy(() => import('../user/userlist')),
        name: '/admin'
    },
    {
        path: "/projectList",
        component: lazy(() => import('../Projects/ListProject.js')),
        name: '/admin'
    },
    {
        path: "/projectView",
        component: lazy(() => import('../Projects/AddProject.js')),
        name: '/admin'
    },
    {
        path: "/projectAdd",
        component: lazy(() => import('../Projects/AddProject.js')),
        name: '/admin'
    },
    {
        path: "/ProjectCmsList",
        component: lazy(() => import('../Projects/ProjectCmsList.js')),
        name: '/admin'
    },
    {
        path: "/ProjectCmsAdd",
        component: lazy(() => import('../Projects/ProjectCmsAdd.js')),
        name: '/admin'
    },
    {
        path: "/ProjectCmsEdit",
        component: lazy(() => import('../Projects/ProjectCmsAdd.js')),
        name: '/admin'
    },
    {
        path: "/projectEdit",
        component: lazy(() => import('../Projects/AddProject.js')),
        name: '/admin'
    },
    {
        path: "/GalleryList",
        component: lazy(() => import('../Gallery/galleryList.js')),
        name: '/admin'
    },
    {
        path: "/GalleryFiles",
        component: lazy(() => import('../Gallery/galleryImages.js')),
        name: '/admin'
    },
    {
        path: "/AddFileData",
        component: lazy(() => import('../Gallery/AddFileData.js')),
        name: '/admin'
    },
    {
        path: "/EditFileData",
        component: lazy(() => import('../Gallery/AddFileData.js')),
        name: '/admin'
    },
    {
        path: "/GalleryAdd",
        component: lazy(() => import('../Gallery/AddGallery.js')),
        name: '/admin'
    },
    {
        path: "/GalleryEdit",
        component: lazy(() => import('../Gallery/AddGallery.js')),
        name: '/admin'
    },
    {
        path: "/KycList",
        component: lazy(() => import('../KYC/KycList.js')),
        name: '/admin'
    },
    {
        path: "/KytList",
        component: lazy(() => import('../KYT/KYTList.js')),
        name: '/admin'
    },
    {
        path: "/feedList",
        component: lazy(() => import('../newsFeed/feedList.js')),
        name: '/admin'
    },
    {
        path: "/feeds",
        component: lazy(() => import('../newsFeed/feeds.js')),
        name: '/admin'
    },
    {
        path: "/feedsAdd",
        component: lazy(() => import('../newsFeed/feedAdd.js')),
        name: '/admin'
    },
    {
        path: "/feedsEdit",
        component: lazy(() => import('../newsFeed/feedAdd.js')),
        name: '/admin'
    },
    {
        path: "/stepList/:projectId",
        component: lazy(() => import('../Projects/steps.js')),
        name: '/admin'
    },
    {
        path: "/addSteps",
        component: lazy(() => import('../Projects/addSteps.js')),
        name: '/admin'
    },
    {
        path: "/editSteps",
        component: lazy(() => import('../Projects/addSteps.js')),
        name: '/admin'
    },
    {
        path: "/stackProjects",
        component: lazy(() => import('../staking/stackProjects.js')),
        name: '/admin'
    },
    {
        path: "/rewardProjects",
        component: lazy(() => import('../staking/stackProjects.js')),
        name: '/admin'
    },
    {
        path: "/projectRewards",
        component: lazy(() => import('../staking/stackProjects.js')),
        name: '/admin'
    },
    {
        path: "/mintReport",
        component: lazy(() => import('../staking/stackProjects.js')),
        name: '/admin'
    },
    {
        path: "/marketPlaceReport",
        component: lazy(() => import('../staking/stackProjects.js')),
        name: '/admin'
    },
    {
        path: "/royaltyReport",
        component: lazy(() => import('../staking/stackProjects.js')),
        name: '/admin'
    },
    {
        path: "/StakingDetails",
        component: lazy(() => import('../staking/stakingDetails.js')),
        name: '/admin'
    },
    {
        path: "/rewardHistory",
        component: lazy(() => import('../staking/rewardHistory.js')),
        name: '/admin'
    },
    {
        path: "/StakingReward",
        component: lazy(() => import('../staking/stakeReward.js')),
        name: '/admin'
    },
    //whitelist
    {
        path: "/addwhitelist",
        component: lazy(() => import('../whitelists/addwhitelist.js')),
        name: '/admin'
    },
    {
        path: "/whitelists",
        component: lazy(() => import('../whitelists/listwhitelist.js')),
        name: '/admin'
    },
    {
        path: "/selectwhitelist/:_id",
        component: lazy(() => import('../whitelists/selectwhitelist.js')),
        name: '/admin'
    },
    {
        path: "/adminList",
        component: lazy(() => import('../Admin/adminList.js')),
        name: '/admin'
    },
    {
        path: "/addAdmin",
        component: lazy(() => import('../Admin/addAdmin.js')),
        name: '/admin'
    },
    {
        path: "/mintList",
        component: lazy(() => import('../Reports/MintReport.js')),
        name: '/admin'
    },
    {
        path: "/activityList",
        component: lazy(() => import('../Reports/ActivityReport.js')),
        name: '/admin'
    },
    {
        path: "/royaltyList",
        component: lazy(() => import('../Reports/RoyaltyReport.js')),
        name: '/admin'
    },
    {
        path: "/refferalFee",
        component: lazy(() => import('../referal/Refferal.js')),
        name: '/admin'
    },
    {
        path: "/referral-management",
        component: lazy(() => import('../referal/RefferalManagement.js')),
        name: '/admin'
    },
    {
        path: "/referral-tree",
        component: lazy(() => import('../referal/ReferralTree.js')),
        name: '/admin'
    },
    {
        path: "/referral-report",
        component: lazy(() => import('../referal/ReferralReport.js')),
        name: '/admin'
    },
    {
        path: "/email-template-list",
        component: lazy(() => import('../EmailTemplate/EmailTemplateList.js')),
        name: '/admin'
    },
    {
        path: "/email-template-edit",
        component: lazy(() => import('../EmailTemplate/EmailTemplateEdit.js')),
        name: '/admin'
    },
    {
        path: "/email-template-add",
        component: lazy(() => import('../EmailTemplate/EmailTemplateEdit.js')),
        name: '/admin'
    },
    {
        path: "/notification-add",
        component: lazy(() => import('../Notification/NotificationAdd.js')),
        name: '/admin'
    },
    {
        path: "/notification-list",
        component: lazy(() => import('../Notification/NotificationList.js')),
        name: '/admin'
    },
    {
        path: "/notification-edit",
        component: lazy(() => import('../Notification/NotificationAdd.js')),
        name: '/admin'
    },
]


export default Routes;
